// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { DisabledAlertSite_abstract } from './../../abstract/SagaBase/Objects/DisabledAlertSite_abstract';
export class DisabledAlertSite extends DisabledAlertSite_abstract {}
